import { Particle } from "../particle";
import {
	colorConstant,
	hold,
	lerp,
	linearMotion,
	randomAngle,
	randomBetween,
	randomSign,
	stopAfter,
} from "../interpolation";

export class ToxicGasBurstParticle extends Particle {
	constructor(originX: number, originY: number) {
		const angle = randomAngle();
		const speed = randomBetween(1.5, 2.8);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		const r = randomBetween(100, 170);
		const g = randomBetween(200, 240);
		const b = randomBetween(70, 120);

		super(originX, originY, {
			ttl: randomBetween(1000, 1400),
			size: lerp(0.65, 0.3),
			opacity: hold(0.75, 0.6, lerp(0.75, 0.0)),
			color: colorConstant(r, g, b),
			rotation: lerp(0, randomSign() * randomBetween(1, 3)),
			position: stopAfter(linearMotion(vx, vy), 0.4),
		});
	}
}
